import { render, staticRenderFns } from "./tcFoot.vue?vue&type=template&id=9e9918de&scoped=true&"
import script from "./tcFoot.vue?vue&type=script&lang=js&"
export * from "./tcFoot.vue?vue&type=script&lang=js&"
import style0 from "./tcFoot.vue?vue&type=style&index=0&id=9e9918de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9918de",
  null
  
)

export default component.exports